import React, { useEffect, useState } from "react";
import "./HelpSteps.scss";
import { getAllHelpSteps } from "../services/getAllHelpSteps";
import { ImageLink } from "../constants";
import axiosInstance from "../axiosInterceptor";

const HelpSteps = ({ subCategoryId, description = "" }) => {
  const [pageData, setPageData] = useState([]);
  const fetchData = async () => {
    await getAllHelpSteps({
      subCategoryId,
    })
      .then((data) => {
        setPageData(data.data[0]);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    fetchData();
  }, []);

  const [setting, setSetting] = useState([]);
  const fetchSettingData = async () => {
    try {
      const res = await axiosInstance.get(`/admin/setting/getSetting`);
      setSetting(res.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchSettingData();
  }, []);

  if (!pageData?.helpSteps?.length) {
    return null;
  }
  return (
    <div className="help-container">
      <div className="help-steps-container">
        <h2 className="title">
          {pageData?.mainTitle ?? "Complete Help in 5 Steps"}
        </h2>
        <div className="description">
          {description || "Get academic support in 4 easy steps."}
        </div>
        <div className="container">
          <div className="row">
            <div className="col-12 col-lg-7">
              {pageData?.helpSteps?.map((item, index) => {
                return (
                  <HelpStepsCard {...item} index={index + 1} key={index} />
                );
              })}
            </div>
            <div className="d-none d-lg-block col-lg-5">
              <img
                src={ImageLink(setting?.completeHelpImage)}
                alt=""
                className="w-100"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const HelpStepsCard = ({ title = "", description = "", index = 0 }) => {
  return (
    <div className="help-steps-card">
      <div className="help-steps-title-parent">
        <span className="help-steps-card-index">
          0{index}
          <span className="help-steps-card-down-arrow" />
        </span>
        <span className="help-steps-card-title">{title}</span>
      </div>
      <span className="help-steps-card-description">{description}</span>
    </div>
  );
};

export default HelpSteps;
